import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import {
  conversionRate,
  customerservicestats,
  dashboard,
  dayweekuser,
  joincategory,
  userage,
  usercategory,
} from "../../services/Mainservice";
import Loader from "../../Loader/Loader";
import "../../assets/Styles/Dashboard.css";

const AnalyticsDashboard = () => {
  const [loading, setloading] = useState(true);
  const [details, setdetails] = useState({});
  const [dailyUserOptions, setdailyUserOptions] = useState();
  const [weeklyUserOptions, setweeklyUserOptions] = useState();
  const [ageOptions, setageOptions] = useState();
  const [genderOptions, setgenderOptions] = useState();
  const [citiesOptions, setcitiesOptions] = useState();
  const [categoriesOptions, setcategoriesOptions] = useState();
  const [customerServiceOptions, setCustomerServiceOptions] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setloading(true);
      const data = await dashboard();
      const data2 = await dayweekuser();
      const data3 = await userage();
      const data4 = await usercategory();
      const data5 = await joincategory();
      const data6 = await conversionRate();
      const data7 = await customerservicestats();
      setloading(false);

      setdetails({
        total: data.data.data,
        conversionRate: data6.data.data,
        mostUsedCategories: data5.data.data,
        // userSegments: data3.data.data.age,
        // usercity: data3.data.data.city,
        // usercity: data3.data.data.city,
        // usercategory: data4.data.data.category,
      });

      const supportStats = data7.data.data || {};
      setCustomerServiceOptions({
        chart: {
          type: "donut",
          height: 350,
          background: "transparent",
          foreColor: "var(--grey4)",
          toolbar: { show: false },
        },
        labels: ["Unanswered", "Replied"],
        series: [
          Number(supportStats.notReplied ?? supportStats.unanswered ?? 0),
          Number(supportStats.replied || 0),
        ],
        colors: ["var(--red)", "var(--red3)"],
        stroke: { colors: ["var(--sidebar)"], width: 3 },
        legend: {
          position: "bottom",
          labels: { colors: "var(--grey4)" },
        },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        plotOptions: {
          pie: {
            donut: {
              size: "68%",
              labels: {
                show: true,
                name: { show: true, color: "var(--grey4)" },
                value: {
                  show: true,
                  color: "var(--white)",
                  fontSize: "24px",
                  fontWeight: 700,
                },
                total: {
                  show: true,
                  label: "All tickets",
                  color: "var(--grey4)",
                  formatter: () => String(supportStats.all || 0),
                },
              },
            },
          },
        },
        noData: {
          text: "No customer service tickets",
          style: { color: "var(--grey4)" },
        },
        responsive: [
          {
            breakpoint: 480,
            options: { chart: { height: 300 }, legend: { position: "bottom" } },
          },
        ],
      });

      setdailyUserOptions({
        ...apexChartOptions,
        series: [
          {
            name: "Daily Users",
            data: Object.values(data2.data.data.daily),
          },
        ],
        xaxis: {
          ...apexChartOptions.xaxis,
          categories: Object.keys(data2.data.data.daily),
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["var(--red3)"],
            shadeIntensity: 1,
            type: "vertical",
            opacityFrom: 0.7,
            opacityTo: 0.1,
            stops: [0, 100],
          },
        },
      });

      // Weekly Users Bar Chart
      setweeklyUserOptions({
        ...apexChartOptions,
        chart: {
          ...apexChartOptions.chart,
          type: "bar",
          height: 350,
        },
        colors: ["var(--red)", "var(--red1)", "var(--red2)"],
        series: [
          {
            name: "Weekly Users",
            data: Object.values(data2.data.data.weekly),
          },
        ],
        xaxis: {
          ...apexChartOptions.xaxis,
          categories: Object.keys(data2.data.data.weekly).map((date) =>
            date.replace(" to ", "\nto ")
          ),
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            columnWidth: "25%",
          },
        },
      });

      setgenderOptions({
        ...apexChartOptions,
        chart: {
          ...apexChartOptions.chart,
          type: "donut",
          height: 300,
        },
        colors: ["var(--grey5)", "var(--red1)", "var(--red2)"],
        labels: data3.data.data.byGender.map((g) => g.gender || "Unknown"),
        series: data3.data.data.byGender.map((g) => parseInt(g.userCount)),
        legend: {
          position: "bottom",
          labels: {
            colors: "var(--grey4)",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "14px",
                  color: "var(--grey4)",
                },
                value: {
                  show: true,
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "var(--white)",
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "var(--grey4)",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  },
                },
              },
            },
          },
        },
      });
      setageOptions({
        chart: {
          type: "bar",
          height: 300,
          toolbar: {
            show: false,
          },
          background: "transparent",
          foreColor: "var(--grey4)",
          animations: {
            enabled: true,
            easing: "easeout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        colors: ["var(--red3)"],
        series: [
          {
            name: "Users",
            data: data3.data.data.byAge.map((a) => a.userCount),
          },
        ],
        xaxis: {
          axisBorder: {
            show: false,
          },
          categories: data3.data.data.byAge.map((a) => a.ageGroup),
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            borderRadiusApplication: "end",
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
      });

      // // Top Cities Radial Chart
      setcitiesOptions({
        chart: {
          type: "radar",
          height: 350,
        },
        colors: ["var(--red3)"],
        series: [
          {
            name: "Users",
            data: data3.data.data.byCity.map((city) => city.userCount),
          },
        ],
        labels: data3.data.data.byCity.map(
          (city) => city?.city || "Not define"
        ),
        plotOptions: {
          radar: {
            size: 140,
            polygons: {
              strokeColor: "var(--transparent)",
              fill: {
                colors: ["transparent"],
              },
            },
          },
        },
        markers: {
          size: 6,
          colors: ["var(--white)"],
          strokeWidth: 3,
          strokeColors: ["var(--red3)"],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " users";
            },
          },
        },
        yaxis: {
          show: false,
        },
      });
      setcategoriesOptions({
        ...apexChartOptions,
        chart: {
          ...apexChartOptions.chart,
          type: "radialBar",
          height: 350,
        },
        colors: [
          "var(--red)",
          "var(--red1)",
          "var(--red2)",
          "var(--red3)",
          "var(--grey4)",
        ],
        series: data5.data.data.map((cat) =>
          Math.round((cat.count / 100) * 100)
        ),
        plotOptions: {
          radialBar: {
            hollow: {
              size: "50%",
              background: "var(--sidebar)",
            },
            track: {
              background: "var(--transparent)",
            },
            dataLabels: {
              name: {
                fontSize: "14px",
                color: "var(--grey4)",
              },
              value: {
                fontSize: "24px",
                fontWeight: "bold",
                color: "var(--white)",
              },
              total: {
                show: true,
                label: "Total",
                color: "var(--grey4)",
                formatter: function (w) {
                  return "100%";
                },
              },
            },
          },
        },
        labels: data5.data.data.map((cat) => cat.name),
        stroke: {
          lineCap: "round",
        },
      });
    } catch (error) {
      setloading(false);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  // Color variables
  const colors = {
    navy: "#0f1225",
    white: "#FFFFFF",
    blurwhite: "rgba(255, 255, 255, 0.871)",
    transparent: "rgba(255, 255, 255, 0.10)",
    red: "rgba(246, 8, 213, 1)",
    red1: "#941EB9",
    red2: "#7513CB",
    red3: "rgba(21, 203, 251, 1)",
    sidebar: "#191e38",
    grey4: "#BDBDBD",
    grey5: "#5F5F5F",
  };

  const apexChartOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      background: "transparent",
      foreColor: "var(--grey4)",
      animations: {
        enabled: true,
        easing: "easeout",
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
    },
    colors: ["var(--red3)"],
    stroke: {
      width: 3,
      curve: "smooth",
    },
    // markers: {
    //   size: 5,
    //   strokeWidth: 0,
    //   colors: ["var(--white)"],
    //   strokeColors: "var(--red3)",
    //   hover: {
    //     size: 7,
    //   },
    // },
    grid: {
      borderColor: "var(--transparent)",
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      labels: {
        style: {
          colors: "var(--grey4)",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "var(--grey4)",
        },
      },
    },
    tooltip: {
      theme: "dark",
      x: {
        show: false,
      },
      marker: {
        show: false,
      },
    },
  };

  return (
    <div className="dashboard-container">
      <header>
        <div>
          <h1 className="dashboard_title">Analytics Dashboard</h1>
        </div>
      </header>

      {/* Summary Cards */}
      <div className="dashboard-cards">
        {details.total &&
          Object.entries(details.total).map(([key, value], index) => (
            <div
              key={key}
              style={{
                backgroundColor: "var(--sidebar)",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: `0 8px 30px rgba(0, 0, 0, 0.3)`,
                border: `1px solid ${"var(--transparent)"}`,
                backdropFilter: "blur(5px)",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-50px",
                  right: "-50px",
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  background: `radial-gradient(circle, ${"var(--red2)"} 0%, transparent 70%)`,
                  opacity: 0.3,
                }}
              ></div>
              <div
                style={{
                  fontSize: "14px",
                  color: "var(--grey4)",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  marginBottom: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "2px",
                    background: "var(--red3)",
                  }}
                ></div>
                {key.replace("total", "")}
              </div>
              <div
                style={{
                  fontSize: "36px",
                  fontWeight: "bold",
                  color: key === "totalUsers" ? "var(--red3)" : "var(--white)",
                  marginBottom: "15px",
                }}
              >
                {value}
              </div>
            </div>
          ))}
      </div>

      <div className="user_behaviour">
        <div className="user_behaviour_content">
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: `linear-gradient(90deg, ${"var(--red)"}, ${"var(--red3)"})`,
            }}
          ></div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h3
              style={{
                margin: 0,
                color: "var(--grey4)",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span>📈</span> Daily Active Users
            </h3>
          </div>
          {dailyUserOptions && (
            <ReactApexChart
              options={dailyUserOptions}
              series={dailyUserOptions?.series}
              type="line"
              height={350}
            />
          )}
        </div>

        <div
          style={{
            backgroundColor: "var(--sidebar)",
            borderRadius: "16px",
            padding: "25px",
            boxShadow: `0 8px 30px rgba(0, 0, 0, 0.3)`,
            border: `1px solid ${"var(--transparent)"}`,
            backdropFilter: "blur(5px)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h3
              style={{
                margin: 0,
                color: "var(--grey4)",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span>📊</span> Weekly Active Users
            </h3>
          </div>
          {weeklyUserOptions && (
            <ReactApexChart
              options={weeklyUserOptions}
              series={weeklyUserOptions.series}
              type="bar"
              height={350}
            />
          )}
        </div>

        <div className="user_behaviour_content">
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, var(--red), var(--red3))",
            }}
          ></div>
          <h3
            style={{
              margin: "0 0 20px",
              color: "var(--grey4)",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            Customer Service Requests
          </h3>
          {customerServiceOptions && (
            <ReactApexChart
              options={customerServiceOptions}
              series={customerServiceOptions.series}
              type="donut"
              height={350}
            />
          )}
        </div>

        {/* Most Used Categories */}
        <div
          style={{
            backgroundColor: "var(--sidebar)",
            borderRadius: "16px",
            padding: "25px",
            boxShadow: `0 8px 30px rgba(0, 0, 0, 0.3)`,
            border: `1px solid ${"var(--transparent)"}`,
            backdropFilter: "blur(5px)",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              marginBottom: "20px",
              color: "var(--grey4)",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span>🏆</span> Most Used Categories
          </h3>
          {categoriesOptions && (
            <ReactApexChart
              options={categoriesOptions}
              series={categoriesOptions.series}
              type="radialBar"
              height={350}
            />
          )}
        </div>
        <div
          style={{
            backgroundColor: "var(--sidebar)",
            borderRadius: "16px",
            padding: "25px",
            boxShadow: `0 8px 30px rgba(0, 0, 0, 0.3)`,
            border: `1px solid ${"var(--transparent)"}`,
            backdropFilter: "blur(5px)",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              marginBottom: "20px",
              color: "var(--grey4)",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span>🌎</span> Top Cities by Users
          </h3>
          {citiesOptions && (
            <ReactApexChart
              options={citiesOptions}
              series={citiesOptions.series}
              type="radar"
              height={350}
            />
          )}
        </div>
      </div>

      {/* User Segmentation */}
      <div
        style={{
          backgroundColor: "var(--sidebar)",
          borderRadius: "16px",
          padding: "25px",
          marginBottom: "30px",
          boxShadow: `0 8px 30px rgba(0, 0, 0, 0.3)`,
          border: `1px solid ${"var(--transparent)"}`,
          backdropFilter: "blur(5px)",
          overflowX: "auto",
          position: "relative",
          zIndex: 10,
        }}
      >
        <h3
          style={{
            marginTop: 0,
            marginBottom: "20px",
            color: "var(--grey4)",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <span>👥</span> User Segmentation
        </h3>
        <div className="segment">
          <div>
            <h4
              style={{
                textAlign: "center",
                color: "var(--grey4)",
                marginBottom: "20px",
              }}
            >
              By Gender
            </h4>
            {genderOptions && (
              <ReactApexChart
                options={genderOptions}
                series={genderOptions.series}
                type="donut"
                height={300}
              />
            )}
          </div>
          <div>
            <h4
              style={{
                textAlign: "center",
                color: "var(--grey4)",
                marginBottom: "20px",
              }}
            >
              By Age Group
            </h4>
            {ageOptions && (
              <ReactApexChart
                options={ageOptions}
                series={ageOptions.series}
                type="bar"
                height={300}
              />
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "var(--sidebar)",
          borderRadius: "16px",
          padding: "25px",
          marginBottom: "30px",
          boxShadow: `0 8px 30px rgba(0, 0, 0, 0.3)`,
          border: `1px solid ${"var(--transparent)"}`,
          backdropFilter: "blur(5px)",
          overflowX: "auto",
          position: "relative",
          zIndex: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3
            style={{
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span>📋</span> Conversion Rates
          </h3>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          ></div>
        </div>
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <table className="data_table">
            <thead>
              <tr
                style={{
                  backgroundColor: "var(--transparent)",
                }}
              >
                <th>Post</th>
                <th>Views</th>
                <th>Joins</th>
                <th>Completions</th>
                <th>Join Rate</th>
                <th>Completion Rate</th>
              </tr>
            </thead>
            <tbody>
              {details?.conversionRate?.map((item, index) => (
                <tr>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "8px",
                          background: `linear-gradient(135deg, ${"var(--red1)"}, ${"var(--red2)"})`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "18px",
                        }}
                      >
                        {item.title.charAt(0)}
                      </div>
                      {item.title}
                    </div>
                  </td>
                  <td>{item.views}</td>
                  <td>{item.joins}</td>
                  <td>{item.completions}</td>
                  <td
                    style={{
                      color:
                        item.joinRate === "0%" ? "var(--grey4)" : "var(--red3)",
                      fontWeight: item.joinRate !== "0%" ? "bold" : "normal",
                    }}
                  >
                    {item.joinRate}
                  </td>
                  <td
                    style={{
                      color:
                        item.completionRate === "0%"
                          ? "var(--grey4)"
                          : "var(--red3)",
                      fontWeight:
                        item.completionRate !== "0%" ? "bold" : "normal",
                      position: "relative",
                      borderTopRightRadius: "12px",
                      borderBottomRightRadius: "12px",
                    }}
                  >
                    {item.completionRate}
                    {parseInt(item.completionRate) > 80 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "5px",
                          transform: "translateY(-50%)",
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: "var(--red3)",
                          boxShadow: `0 0 10px ${"var(--red3)"}`,
                        }}
                      ></div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
      <footer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        style={{
          textAlign: "center",
          padding: "20px",
          color: "var(--grey4)",
          fontSize: "14px",
          position: "relative",
          zIndex: 10,
        }}
      >
        <div>Analytics Dashboard • Data updated: June 26, 2025</div>
        <div
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          {details?.mostUsedCategories?.slice(0, 4).map((cat, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "3px",
                  background: [
                    "var(--red)",
                    "var(--red1)",
                    "var(--red2)",
                    "var(--red3)",
                  ][index],
                }}
              ></div>
              <span>
                {cat.categoryName} ({cat.usageCount})
              </span>
            </div>
          ))}
        </div>
      </footer>
      {loading && <Loader />}
    </div>
  );
};

export default AnalyticsDashboard;
